import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/home.vue'
import ProfitAndLoss1 from '../components/profitloss1.vue'
import SettledGames from '../components/settledgames.vue'
import SettledGamesDetail from '../components/settledgamesdetail.vue'
import BetSlips from '../components/betslips.vue'
import CompanyReport from '../components/companyreport.vue'
import Test from '../components/test.vue'
import CollectionReport from '../components/collectionreport.vue'
import Clients from '../components/clients.vue'
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/clients/:id/:id1',
        name: 'Clients',
        component: Clients
    }, {
        path: '/profitandlossbyclient/:id',
        name: 'ProfitAndLossByClient',
        component: ProfitAndLoss1
    }, {
        path: '/profitandloss',
        name: 'ProfitAndLoss1',
        component: ProfitAndLoss1
    },
    {
        path: '/settledGames',
        name: 'SettledGames',
        component: SettledGames
    },
    {
        path: '/settledgamedetails/:id/:id1/:sp',
        name: 'SettledGamesDetails',
        component: SettledGamesDetail
    },
    {
        path: '/betslips2/:id/:id1/:sp',
        name: 'BetSlips2',
        component: BetSlips
    },
    {
        path: '/sessionbetslips/:id/:id1/:sp',
        name: 'SessionBetSlips',
        component: BetSlips
    },
    {
        path: '/companyreport/:id/:id1/:sp',
        name: 'CompanyReport',
        component: CompanyReport
    },
    {
        path: '/collectionreport1/:id/:id1/:sp',
        name: 'CollectionReport1',
        component: CompanyReport
    },
    {
        path: '/clientreport/:id/:id1/:sp',
        name: 'ClientReport',
        component: CompanyReport
    },
    {
        path: '/sessionearningsreport/:id/:id1/:sp',
        name: 'SessionEarningsReport',
        component: CompanyReport
    }
    , {
        path: '/CollectionReport',
        name: 'CollectionReport',
        component: CollectionReport
    },
    {
        path: '/test',
        name: Test,
        component: Test
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
]

const router = createRouter({
    history: createWebHistory('/'),
    routes,
    scrollBehavior: function (to, _from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { el: to.hash, behavior: "smooth" };
        } else {
            //console.log("moving to top of the page");
            window.scrollTo(0, 0);
        }
        if (WURFL !== undefined && WURFL.is_mobile !== undefined && WURFL.is_mobile) {
            if ($(".sidebar").hasClass("open")) {
                $('.sidebar, .content').toggleClass("open");
            }
            if ($(".content").hasClass("open")) {
                $(".content").removeClass("open");
            }
        }
    }
});

export default router
